module.exports = __webpack_public_path__ + "img/d.94ca0a06.jpg";